import formatName from 'I18n/utils/formatName';
export const getFormattedContactDetail = (firstName, lastName, email, phoneNumber) => {
  return !firstName || !lastName ? email || phoneNumber || '' : formatName({
    firstName,
    lastName
  });
};